module.exports = __webpack_public_path__ + "img/room-3.60642a7e.jpg";